module.exports = "https://static.wmbcdn.com/uniweb/images/077cdd80e865068e4d36ef127e827f48.svg";